// extracted by mini-css-extract-plugin
export default {"todoModal":"Todo_todoModal__pVqCl"};